// extracted by mini-css-extract-plugin
module.exports = {"textarea":"form-textarea_textarea__R0zk_","error":"form-textarea_error__eMfgD","error-message":"form-textarea_error-message__uTnvZ"};